import { createReducer } from '@reduxjs/toolkit'

import { PCRChannels } from '@enums'
import { AuthActionTypes } from '@store/auth'
import { indexById } from '@utils/groupBy'
import { fetchPcrMetrics, fetchPcrMetricsError, fetchPcrMetricsSuccess } from './action'
import { IPCRMetrics, IPCRMetricsState } from './types'

const initialState: IPCRMetricsState = {
  isFetching: false,
  errors: undefined,
  metricsById: {},
  metricIdsByCampaignId: {},
  metricsSummaryByCampaignId: {},
}

export const generatePCRMetricsReducer = (targetChannel: PCRChannels) => {
  return createReducer(initialState, (builder) => {
    builder
      .addCase(fetchPcrMetrics, (state, { payload }) => {
        const { pcrChannel } = payload
        if (pcrChannel === targetChannel) {
          state.isFetching = true
        }
      })
      .addCase(fetchPcrMetricsSuccess, (state, { payload }) => {
        const { campaignId, pcrChannel, metrics } = payload
        if (pcrChannel === targetChannel) {
          state.errors = undefined
          state.isFetching = false
          state.metricsById = {
            ...state.metricsById,
            ...indexById(metrics.items, state.metricsById, 'submission_id'),
          }

          state.metricsSummaryByCampaignId = {
            ...state.metricsSummaryByCampaignId,
            [campaignId]: metrics.metadata,
          }

          state.metricIdsByCampaignId = {
            ...state.metricIdsByCampaignId,
            [campaignId]: metrics.items.map((metric: IPCRMetrics) => metric.submission_id),
          }
        }
      })
      .addCase(fetchPcrMetricsError, (state, { payload }) => {
        const { pcrChannel, errors } = payload
        if (pcrChannel === targetChannel) {
          state.isFetching = false
          state.errors = errors
        }
      })
      .addMatcher(
        (action) => action.type === AuthActionTypes.SIGNOUT_SUCCESS,
        () => initialState,
      )
  })
}

export { initialState as pcrMetricsInitialState }
